
export class Organization {
  id: number;
  name: string;
  short_name: string;
  description : string;
  site_url: string;
  parent_id: number | null;

  constructor() {
    this.id = -1;
    this.name = "";
    this.short_name = "";
    this.description = "";
    this.site_url = "";
    this.parent_id = null;
  }
}


